import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

const SiteStatus = (props) => {
  const { t, data, isActive } = props;

  return (
    <>
      <DivBackgroundOpacity opacity={isActive ? 1 : "0.2"}>
        {data === 11 && (
          <ColumnButton
            border="#0A4986"
            background="#0A4986"
            marginRight="10px"
          >
            {t("SITE_STATUS_DRAFT")}
          </ColumnButton>
        )}
        {data === 1 && (
          <ColumnButton
            border="#00AEEA"
            background="#00AEEA"
            marginRight="10px"
          >
            {t("SITE_STATUS_QUOTATION")}
          </ColumnButton>
        )}
        {data === 2 && (
          <ColumnButton
            border="#008395"
            background="#008395"
            marginRight="10px"
          >
            {t("SITE_STATUS_QUOTE_SENT")}
          </ColumnButton>
        )}
        {data === 6 && (
          <ColumnButton
            border="#D9D9D9"
            background="#D9D9D9"
            marginRight="10px"
          >
            {t("SITE_STATUS_LOST_PARTNER")}
          </ColumnButton>
        )}
        {data === 5 && (
          <ColumnButton
            border="#E83F1E"
            background="#E83F1E"
            marginRight="10px"
          >
            {t("SITE_STATUS_LOST_CLIENT")}
          </ColumnButton>
        )}
        {data === 4 && (
          <ColumnButton
            border="#E83F1E"
            background="#E83F1E"
            marginRight="10px"
          >
            {t("SITE_STATUS_LOST_HESUS")}
          </ColumnButton>
        )}
        {data === 3 && (
          <ColumnButton
            border="#32A728"
            background="#32A728"
            marginRight="10px"
          >
            {t("SITE_STATUS_WON")}
          </ColumnButton>
        )}
        {data === 9 && (
          <ColumnButton
            border="#F08046"
            background="#F08046"
            marginRight="10px"
          >
            {t("SITE_STATUS_PENDING")}
          </ColumnButton>
        )}
        {data === 10 && (
          <ColumnButton
            border="#D9D9D9"
            background="#D9D9D9"
            marginRight="10px"
          >
            {t("SITE_STATUS_CANCELED")}
          </ColumnButton>
        )}
        {data === 12 && (
          <ColumnButton
            border="#EFCA06"
            background="#EFCA06"
            marginRight="10px"
          >
            {t("SITE_STATUS_READY_TO_START")}
          </ColumnButton>
        )}
        {data === 13 && (
          <ColumnButton
            border="#FF981E"
            background="#FF981E"
            marginRight="10px"
          >
            {t("SITE_STATUS_IN_PROGRESS")}
          </ColumnButton>
        )}
        {data === 14 && (
          <ColumnButton
            border="#712DC9"
            background="#712DC9"
            marginRight="10px"
          >
            {t("SITE_STATUS_PAUSED")}
          </ColumnButton>
        )}
        {data === 15 && (
          <ColumnButton
            border="#0A6800"
            background="#0A6800"
            marginRight="10px"
          >
            {t("SITE_STATUS_FINISHED")}
          </ColumnButton>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

SiteStatus.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(SiteStatus);
